/** Records the error as a RUM js_error_event, outside the XB metrics. */
export const recordRumError = (error: unknown): void => {
  try {
    window.cwr?.recordError(error);
  } catch (recordFailure) {
    console.error("Failed to record error in RUM", { recordFailure });
  }
};
